export const CONVERSATIONS_LOADING  = "CONVERSATIONS_LOADING";
export const SET_CONVERSATIONS  = "SET_CONVERSATIONS";